<template>
  <div class="child-view">
    <router-view />
    <Toast />
    <policy-popup :isShow="showpPolicyPopup" @onConfirm="handleConfirmPolicy" @onCancel="handleRefusePolicy" />
  </div>
</template>

<style>
.child-view {
  /*position: absolute;*/
  /*transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);*/
  /*-webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);*/
  width: 100%;
  height: 100%;
}
</style>

<script>
import "../../ui/static/mobile/css/invoice.css"
import "../../ui/static/mobile/css/icon.css"
import { mapActions } from "vuex"
import Toast from "./common/toast.vue"
import policyPopup from "./common/policyPopup.vue"
import * as reportDic from "../constants/report-dictionary"
import * as performanceApi from "../api/performance"
import * as weixinApi from "../api/weixinJSBridge"
import * as mqqApi from "../api/mqq"
import { loadScript, getUserAgent } from "@tencent/midas-util"

export default {
  beforeRouteEnter() {
    window.addEventListener(
      "pageshow",
      e => {
        if (e.persisted) {
          // 从缓存加载
          location.reload()
        }
      },
      false
    )
  },

  created() {
    // 弹出用户隐私协议弹窗
    const agreePolicy = localStorage.getItem("agreePolicy")
    if (!agreePolicy) {
      this.showpPolicyPopup = true
    } else {
      this.loginState()
    }

    //IOS微信内禁止微信分享
    if (getUserAgent().iOS && getUserAgent().weixin) {
      weixinApi.hideOptionMenu()
    }
    //微信下禁止分享
    if (getUserAgent().weixin) {
      // weixinApi.hideOptionMenu()
    } else if (getUserAgent().QQ) {
      //QQ下隐藏右上角功能按钮 | 禁止分享的参数_wv=49945 + 32（隐藏功能菜单里的「复制链接」项）
      mqqApi.hideTitleRight()
    }
  },

  mounted() {
    window.addEventListener("load", () => {
      loadScript("//midas.gtimg.cn/h5pay/js/api/performance_report.js", () => {
        /* global midasPerformanceReport  */
        let speedData = {
          iformat: reportDic.PAGE_VIEW.PV,
          webversion: `${this.$store.getters.pf}${process.env.VERSION.toString().replace(/\./g, "_")}`
        }
        speedData.times = performanceApi.getTimes()
        if (speedData.times) {
          speedData.performanceTiming = performanceApi.getPerformanceTiming()
          speedData.resourceTiming = performanceApi.getEntryTiming()
        }
        speedData.times && midasPerformanceReport(speedData)
      })
    })
  },

  data() {
    return {
      showpPolicyPopup: false
    }
  },

  components: {
    Toast,
    policyPopup
  },

  computed: {},

  methods: {
    ...mapActions([
      "getLoginState",
      "initCgi",
      "setSessionObj",
      "reportError",
      "setRavenContext",
      "setSessionType",
      "setUserNickNameAndAvatar"
    ]),

    loginState() {
      // 获取登录态
      this.getLoginState()
        .then(loginState => {
          this.setRavenContext(loginState)
          this.setSessionObj(loginState)
          this.setSessionType(loginState)
          this.setUserNickNameAndAvatar()
          this.initCgi()
          window.INDEX_RENDER_TIME = +new Date()
        })
        .catch(err => {
          this.reportError(err, "user-module-catch-getUserSession")
        })
    },
    handleConfirmPolicy() {
      this.showpPolicyPopup = false
      localStorage.setItem("agreePolicy", "true")
      this.loginState()
    },
    handleRefusePolicy() {
      this.showpPolicyPopup = false
      // localStorage.setItem("agreePolicy", "false")
    }
  }
}
</script>
